import { render, staticRenderFns } from "./AdutiPointComponent.vue?vue&type=template&id=a9475cd4&scoped=true"
import script from "./AdutiPointComponent.vue?vue&type=script&lang=js"
export * from "./AdutiPointComponent.vue?vue&type=script&lang=js"
import style0 from "./AdutiPointComponent.vue?vue&type=style&index=0&id=a9475cd4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9475cd4",
  null
  
)

export default component.exports